import React, { useCallback, useMemo } from "react";
import MapMultiple from "../../../../Components/General/Map/MapMultiple/MapMultiple";
import { Loader } from '@mantine/core';

const MapEstablishmentList = React.memo(({
  title,
  zoom = 4,
  selectedEstablishmentSiep,
  onSelectEstablishment,
  fullscreen = false,
  establishments = [],
  isLoadingEstablishments = false,
  mapboxStyles,
  leftPanel = null,
	rightPanel = null,
	actionButtons = null,
}) => {

  const handleMarkerClick = useCallback(establishment => {
    onSelectEstablishment(establishment);
  }, [onSelectEstablishment]);

  const pointsData = useMemo(() => {
    return establishments;
  }, [establishments]);

  const selectedEstablishmentId = useMemo(() => {
    const found = establishments?.find(
      establishment =>
        establishment.code_siep?.toString() === selectedEstablishmentSiep
    );
    return found?.id;
  }, [establishments, selectedEstablishmentSiep]);

  if (isLoadingEstablishments) {
    return (
      <div className="map-size mapboxgl-map d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
        <Loader size={30} />
      </div>
    );
  }

  return (
    <React.Fragment>
      <MapMultiple
        title={title}
        points={pointsData}
        zoom={zoom}
        selectedEstablishmentId={selectedEstablishmentId}
        handleMarkerClick={handleMarkerClick}
        fullscreen={fullscreen}
        showHexagons={false}
        mapboxStyles={mapboxStyles}
        leftPanel={leftPanel}
        rightPanel={rightPanel}
        actionButtons={actionButtons}
      />
    </React.Fragment>
  );
});

export { MapEstablishmentList };
